import Chip from "@mui/material/Chip";
import React from "react";
import { RxCross2 } from "react-icons/rx";
import { deleteFilterHandler } from "./deletSingleFilter";

const FilterList = ({
  setData,
  hasRestoredFromSession,
  setPage,
  selectedContents,
  setSelectedContents,
  setUpdate,
  setIsOpen,
  update,
  formik,
  hasRestoredRef,
  fromTransit = false,
  fromKanban = false,
  fromPhotography = false,
  fromConservation = false,
  setTodoPage,
  setphotographyPage,
  setphotoCompletePage,
  setreshootPage,
  setConservationCompletePage,
  setConservationPage,
  setConditionalPage,
  objectCount = 0,
  isClearAll,
  setIsClearAll,
}) => {
  const discardGlobal = () => {
    setIsClearAll(true);
    if (hasRestoredFromSession) {
      hasRestoredFromSession.current = false;
    }
    if (fromTransit) {
      hasRestoredRef.current = false;
      formik?.resetForm({
        values: {
          ...formik?.initialValues, // reset all fields to their initial values
          room: formik?.values?.room,
          selectedRoom: formik?.values?.selectedRoom,
          category_id: formik?.values?.category_id,
          selectedSubCategory: formik?.values?.selectedSubCategory,
          primary_category: formik?.values?.primary_category,
          selectedCategory: formik?.values?.selectedCategory,
        },
      });
    } else {
      formik?.resetForm();
    }
    if (fromKanban) {
      if (fromPhotography) {
        setTodoPage(1);
        setphotographyPage(1);
        setphotoCompletePage(1);
        setreshootPage(1);
      } else {
        setTodoPage(1);
        setConditionalPage(1);
        setConservationPage(1);
        setConservationCompletePage(1);
      }
    } else {
      setPage(1);
    }
    setUpdate(!update);
    setSelectedContents([]);
    formik?.resetForm();
    setIsOpen(false);
  };
  return (
    <div>
      {selectedContents?.length > 0 && (
        <div
          style={{ width: "100%", maxHeight: "118px" }}
          className="selected-content-list"
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <p style={{ marginLeft: "11px", fontWeight: "600" }}>Filters</p>
            <p>
              <span style={{ fontWeight: "600", color: "#20409A" }}>
                {`(${objectCount})`}
              </span>
            </p>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              {selectedContents?.map((li, indexOfDelete) => (
                <Chip
                  className="global-search-chip"
                  label={
                    li?.title === "Iconic object" ||
                    li?.title === "Reference image" ||
                    li?.title === "Drive url" ||
                    li?.title === "Digital image status" ||
                    li?.title === "Assigned to me"
                      ? li?.value
                      : li?.value === "blank"
                      ? "No condition grading"
                      : `${li.title}: ${li?.value}`
                  }
                  deleteIcon={<RxCross2 color="#4b535e" />}
                  onDelete={() => {
                    if (hasRestoredFromSession) {
                      hasRestoredFromSession.current = false;
                    }
                    if (hasRestoredRef) {
                      hasRestoredRef.current = false;
                    }
                    deleteFilterHandler(
                      li,
                      indexOfDelete,
                      setSelectedContents,
                      formik,
                      setUpdate,
                      setPage,
                      fromKanban,
                      setIsClearAll
                    );
                    if (fromKanban) {
                      if (fromPhotography) {
                        setTodoPage(1);
                        setphotographyPage(1);
                        setphotoCompletePage(1);
                        setreshootPage(1);
                      } else {
                        setTodoPage(1);
                        setConditionalPage(1);
                        setConservationPage(1);
                        setConservationCompletePage(1);
                      }
                    }
                  }}
                />
              ))}
            </div>
            <span
              onClick={discardGlobal}
              style={{ color: "#2179eb", width: "118px", cursor: "pointer" }}
            >
              Clear all
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterList;
